import "./node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import "vue";
import "./packages/icons/dist/esm/icons/circle-check-icon.js";
import "./packages/icons/dist/esm/icons/circle-exclamation-icon.js";
import "./packages/icons/dist/esm/icons/triangle-exclamation-icon.js";
import "./packages/icons/dist/esm/icons/circle-info-icon.js";
import "./packages/icons/dist/esm/icons/bell-icon.js";
const t = (r) => r.toUpperCase().replace("-", "").replace("_", "");
function m(r) {
  return r.replace(/([-_][a-z])/gi, t);
}
const l = (r) => r.charAt(0).toUpperCase() + r.slice(1);
export {
  m as toCamelCase,
  l as ucfirst
};
